var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('iq-card',{staticClass:"text-center",staticStyle:{"padding":"20%"}},[_c('img',{staticClass:"mx-auto",staticStyle:{"width":"6.5rem"},attrs:{"src":_vm.loader,"alt":"loader"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }